import { useCallback } from 'react';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { patchApplication } from '~/store/actions/loanApplicationActions';
import { updateForm } from '~/store/slices/loanApplication.slice';

const useSubmit = () => {
  const dispatch = useAppDispatch();

  const onSubmit = useCallback(async () => {
    dispatch(pushToGtmLoanAction({ actionName: 'submit_button_pressed' }));
    dispatch(updateForm({ applicantIdentified: true }));
    dispatch(patchApplication({ finalized: true }));
  }, [dispatch]);

  return onSubmit;
};

export default useSubmit;
